import { DtoRequestRemotesPostReq } from "./abst/DtoRequestRemotesPostReq";
import { EntityRequest } from "../entity/EntityRequest";

export class DtoRequestRemotesPostReqImple extends DtoRequestRemotesPostReq {
  public request = new EntityRequest();

  public IsValidImple(chkPager: boolean): string[] {
    let res: string[] = new Array();
    //ページャー用入力値チェック

    return res;
  }
}
